// extracted by mini-css-extract-plugin
export default {"greenTickIconContainer":"MembershipTrialSuccess_greenTickIconContainer__S-dBz"};